import { useEffect, useRef, useState } from "react";

const SelectDropdown = ({ options, value, onChange, placeholder = "Select", className }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onDown = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
        document.addEventListener("mousedown", onDown);
        return () => document.removeEventListener("mousedown", onDown);
    }, []);

    const selected = options.find((o) => o.value === value);

    const handleSelect = (next) => {
        onChange(next);
        setOpen(false);
    };

    return (
        <div className={`select-dropdown${className ? ` ${className}` : ""}`} ref={ref}>
            <button type="button" className="select-dropdown__toggle" onClick={() => setOpen((o) => !o)}>
                <span>{selected ? selected.label : placeholder}</span>
                <span className="select-dropdown__caret" aria-hidden="true" />
            </button>

            {open && (
                <div className="select-dropdown__menu">
                    {options.map((opt) => (
                        <button
                            key={opt.value}
                            type="button"
                            className={`select-dropdown__option${opt.value === value ? " is-selected" : ""}`}
                            onClick={() => handleSelect(opt.value)}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SelectDropdown;
